import Classic from "./Classic";

export const templates = [
    {
        name: "@system/mobile/layout-classic",
        Component: Classic,
        pure: true,
    },
];